<script>
import { isDark } from '~/vue/color.js'

export const GENERIC_COLORS = {
  black: '#000',
  brown: '#9A4E38',
  green: '#108410',
  blue: '#1268A9',
  purple: '#80027C',
  red: '#D00403',
  copper: '#B87333',
  maroon: '#800000',
  white: '#FFF',
  gray: '#777',
  silver: '#CCC',
  gold: '#D6A850',
  tan: '#B39977',
  yellow: '#FFD702',
  orange: '#FF8C02',
  teal: '#2493B2'
}

// make sure we compute the colorWheel just once
let colorWheel = null
function getColorWheel (h) {
  if (colorWheel) return colorWheel

  const COLORS = [
    'FFCF00', 'FFA600', 'FF7E01', 'FE2100', 'F52494', '8B21BB',
    '0123BA', '0079C7', '00B2D4', '00B600', '83CE01'
  ]

  colorWheel = COLORS.map((color, i) => h('circle', {
    attrs: {
      r: 5,
      cx: 12,
      cy: 12,
      key: i,
      fill: 'none',
      stroke: '#' + color,
      'stroke-width': 10,
      'stroke-dasharray': `${9.08 * 31.4 / 100} 31.4`, // 11 slices
      transform: `rotate(${i * 32.727} 12 12)`
    }
  }))
  return colorWheel
}

export default {
  name: 'ColorWell',
  functional: true,
  props: {
    color: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    }
  },

  render (h, { data, props: { color, size } }) {
    // we must show flywheel icon if we don't have a valid hex color or GENERIC_COLORS
    const background = color?.[0] === '#' ? color : GENERIC_COLORS[color?.toLowerCase()]
    const showStroke = background && !isDark(background)

    return h('svg', {
      class: ['color-well', data.staticClass],
      attrs: {
        height: size,
        width: size,
        viewBox: '0 0 24 24'
      }
    },
    [
      (background)
        ? h('circle', {
          attrs: {
            r: showStroke ? 9.5 : 10,
            stroke: showStroke && '#404040',
            cx: 12,
            cy: 12,
            fill: background
          }
        })
        : getColorWheel(h)
    ])
  }
}
</script>

<style>
.color-well {
  vertical-align: middle;
}
</style>
